'use strict';

/* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
angular.module('AcaApp').controller('CreateAccountController', [
  '$scope',
  '$location',
  '$routeParams',
  'SecurityService',
  'UtilsService',
  'EXCEPTION',
  'UserService',
  'PASSWORD_MESSAGES',
  '$mdDialog',
  function($scope, $location, $routeParams, SecurityService, UtilsService, EXCEPTION, UserService, PASSWORD_MESSAGES, $mdDialog){
    $scope.user = {};
    $scope.showNameRequiered = false;
    $scope.showPasswordRequired = false;
    $scope.showAnswer1Required = false;
    $scope.showAnswer2Required = false;
    $scope.showAnswer3Required = false;
    $scope.eventShowReenterRequired = false;
    $scope.updateFullUser = {SecurityAnswers: []};
    $scope.answers = {};
    $scope.selectedQuestion = {};
    $scope.selectedQuestion.questionId1 = null;
    $scope.selectedQuestion.questionId2 = null;
    $scope.selectedQuestion.questionId3 = null;
    $scope.step = 1;
    $scope.errorMessage = '';
    $scope.securityQuestion = {};
    $scope.securityQuestion.one = {};
    $scope.securityQuestion.two = {};
    $scope.securityQuestion.three = {};
    $scope.specialCharsMsge = PASSWORD_MESSAGES.SPECIAL_CHARS;

    if($routeParams.token){
      $scope.token = $routeParams.token;
      SecurityService.validateToken($scope.token, 'true').then(function(data){
        if(data.result){
          $scope.user.realname = data.result.RealName;
          $scope.user.emailAddress = data.result.EmailAddress;
          $scope.step = 1;
        }
        else{
          $scope.step = 6;
        }
      },
      function(error){
        if(error.data.error.frontend_code === EXCEPTION.INVALIDTOKEN){
          $scope.step = 6;
        }
        else{
          $scope.errorMessage = (error.data.error.frontend_message || undefined);
          $location.path('/');
        }
      });
    }
    else{
      $location.path('/');
    }

    $scope.submitName = function(form){
      if(form.$valid) {
        $scope.updateFullUser.RealName = $scope.user.realname;
        SecurityService.getSecurityQuestions().then(function(data){
          $scope.secQuestions = data.result;
          $scope.step = 2;
        });
      }
      else{
        $scope.eventShowEnterNameFormRequiered();
      }
    };
    $scope.submitPassword = function(form){
      if(form.$valid){
        if($scope.validation()){
          $scope.step = 3;
          $scope.updateFullUser.Password = $scope.user.password1;
        }
      }
      else{
        $scope.eventShowPasswordRequired();
        $scope.eventShowReenterRequired();
      }
    };
    $scope.submitSecurityQuestions = function(){
      $scope.step = 4;
    };
    $scope.goHome = function(){
      $scope.cleanURL();
      $location.path('/login');
    };
    $scope.createAccount = function(){
      UserService.updateFullUser($scope.token, $scope.updateFullUser).then(function(){
        $scope.step = 5;
      },
      function(error){
        $scope.errorMessage = (error.data.error.frontend_code || undefined);
        showError(callbackStep3);
      });
    };
    $scope.eventShowEnterNameFormRequiered = function(){
      $scope.showNameRequiered = true;
      $scope.errorMessage = '';
    };
    $scope.eventShowPasswordRequired = function(){
      $scope.showPasswordRequired = true;
      $scope.errorMessage = '';
    };
    $scope.eventShowReenterRequired = function(){
      $scope.showReenterRequired = true;
      $scope.errorMessage = '';
    };
    $scope.eventShowAnswer1Required = function(){
      $scope.showAnswer1Required = true;
      $scope.errorMessage = '';
    };
    $scope.eventShowAnswer2Required = function(){
      $scope.showAnswer2Required = true;
      $scope.errorMessage = '';
    };
    $scope.eventShowAnswer3Required = function(){
      $scope.showAnswer3Required = true;
      $scope.errorMessage = '';
    };
    $scope.validation = function(){
      var passwordValidation = UtilsService.validatePassword(
        $scope.user.password1,
        $scope.user.password2);
      if(!passwordValidation.value){
        $scope.errorMessage = passwordValidation.msg;
        return false;
      }
      else{
        $scope.errorMessage = '';
        return true;
      }
    };
    $scope.ProcessSecQuest = function(form){
      if(form.$valid){
        $scope.securityQuestion.one = _.find($scope.secQuestions, {Id: $scope.selectedQuestion.questionId1});
        $scope.securityQuestion.two = _.find($scope.secQuestions, {Id: $scope.selectedQuestion.questionId2});
        $scope.securityQuestion.three = _.find($scope.secQuestions, {Id: $scope.selectedQuestion.questionId3});
        $scope.updateFullUser.SecurityAnswers.push({
          'QuestionId': $scope.selectedQuestion.questionId1,
          'Answer': $scope.answers.answer1
        });
        $scope.updateFullUser.SecurityAnswers.push({
          'QuestionId': $scope.selectedQuestion.questionId2,
          'Answer': $scope.answers.answer2
        });
        $scope.updateFullUser.SecurityAnswers.push({
          'QuestionId': $scope.selectedQuestion.questionId3,
          'Answer': $scope.answers.answer3
        });
        $scope.step = 4;
      }
      else{
        $scope.eventShowAnswer1Required();
        $scope.eventShowAnswer2Required();
        $scope.eventShowAnswer3Required();
      }
    };
    $scope.cleanURL = function(){
      $location.$$search = {};
    };
    var showError = function(fCallbackStep3){
      if($scope.errorMessage === 'SECURITY_ANSWER_DUPLICATE') {
        $mdDialog.show({
          controller: [
            '$scope',
            '$mdDialog',
            function ($scope, $mdDialog) {
              $scope.titleUI = 'Security Answer Duplicate';
              $scope.descriptionUI = 'The answers you provided for your security questions are not unique. Please enter unique answers';
              $scope.closeModal = function () {
                $mdDialog.hide();
                fCallbackStep3();
              };
            }
          ],
          templateUrl: 'app/views/createAccount/modals/answerDuplicate.html'
        });
      }
    };
    var callbackStep3 = function(){
      $scope.updateFullUser.SecurityAnswers = [];
      $scope.step = 3;
    }
  }
]);
